







import { Component, Vue, Prop } from "vue-property-decorator";
import TrackingInitiativeComp from "@/components/TrackingInitiativeComp.vue";
import NotLoggedPanel from "@/components/NotLoggedPanel.vue";
import { User } from "@/models/user";

@Component({
  name: "TrackingInitiative",
  components: {
    TrackingInitiativeComp,
    NotLoggedPanel,
  },
})
export default class TrackingInitiative extends Vue {
  @Prop() private user!: User;
}
